import React from "react";
import { Link } from "react-router-dom";
import getPictureUrl from "../../../../lib/getPictureUrl";

const ItemSection = ({
  pathname,
  search,
  hash,
  className,
  item,
  itemEnabled
}) => {
  const itemPicture = getPictureUrl(item.pictures, 500, 500);
  return (
    <Link
      to={{
        pathname,
        search,
        hash
      }}
      replace={true}
      className="d-flex justify-content-between align-items-center"
    >
      <div className="item-quantity-with-image">
        <div className="visible-xs">
          {(item.selected && (
            <span className="item-quantity ">{item.selected}x</span>
          )) || <noscript />}
        </div>
        {itemPicture && (
          <div className="list-img">
            <img src={itemPicture} />
          </div>
        )}
      </div>

      <div className="d-flex justify-content-between flex-grow-1">
        <div className={className}>
          <div className="d-flex align-items-center">
            <div>
              <div className="d-flex item-div">
                <span>{item.name}</span>
                {(item.types &&
                  item.types.length &&
                  item.types.map(type => (
                    <React.Fragment key={type.id}>
                      <span
                        className={`badge ${(type.id === 7 && "blue") || ""}`}
                      >
                        {type.name}
                      </span>
                    </React.Fragment>
                  ))) || <noscript />}
              </div>
              <p className="light">{item.description}</p>
            </div>
          </div>
          {/* /.d-flex */}
        </div>

        <div className="pricing">
          {(item.selected && (
            <span className="item-quantity hide-xs">{item.selected}x</span>
          )) || <noscript />}
          {(itemEnabled &&
            ((item.oldAmount && (
              <div>
                <p className="old">£{parseFloat(item.oldAmount).toFixed(2)}</p>
                <p>
                  {(item.newAmount === 0 && item.freebie && (
                    <span className="color-blue">Free</span>
                  )) || <span> £{parseFloat(item.newAmount).toFixed(2)}</span>}
                </p>
              </div>
            )) || <p>£{parseFloat(item.newAmount).toFixed(2)}</p>)) || (
            <p className="sold-out">Sold out</p>
          )}
          <label className="plus">
            <i />
          </label>
        </div>
        {/* /.pricing */}
      </div>
      {/* /.d-flex */}
    </Link>
  );
};

export default ItemSection;
